/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import LatestBlogs from "./LatestBlogs.container";

export default LatestBlogs;
